/* React */
import React, { useState, useEffect } from "react";

/* React Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { setStateSegments } from "src/redux/features/custom-cohorts/customCohortsSlice";

/* Utils */
import { deleteSegment } from "src/utils/helper/custom-cohorts";

/* Components */
import StatusContainer from "src/components/insights/custom-cohorts/status-container/StatusContainer";
import CohortName from "src/components/insights/custom-cohorts/cohort-builder/cohort-name/CohortName";
import CohortSegment from "src/components/insights/custom-cohorts/cohort-builder/cohort-segment/CohortSegment";
import Options from "src/components/insights/custom-cohorts/cohort-builder/options/Options";

/* Stylesheet */
import styles from "./CohortBuilder.module.scss";

/* Interfaces */
import {
  Status,
  BasicProps,
  LogicalProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

const CohortBuilder: React.FC = () => {
  const dispatch = useDispatch();
  const customCohortsState = useSelector(
    (state: RootState) => state.customCohorts
  );

  const { customCohort } = customCohortsState;

  const {
    name,
    status,
    data: customCohortData,
  } = customCohort;

  const disabled: boolean =
    status === Status.SAVED || status === Status.MODIFIED;

  const featureTypesState = useSelector(
    (state: RootState) => state.featureTypes
  );

  const { data: featureData } = featureTypesState;

  const [segments, setSegments] = useState<
    BasicProps | LogicalProps | undefined
  >(undefined);

  useEffect(() => {
    setSegments(customCohortData);
  }, [customCohortData]);

  const handleSegments = (
    segment?: BasicProps | LogicalProps
  ) => {
    setSegments(segment);
    dispatch(setStateSegments(segment));
  };

  const handleDeleteSegment = (indexPath: number[]) => {
    if (!segments) return;
    const updatedSegments = deleteSegment(
      segments as LogicalProps,
      indexPath
    );
    handleSegments(updatedSegments);
  };

  return (
    <div className={styles.cohort_builder}>
      {segments ? (
        <>
          <StatusContainer status={status} />
          <CohortName name={name} disabled={disabled} />
        </>
      ) : undefined}
      <CohortSegment
        segments={segments!}
        featureTypes={featureData!}
        disabled={disabled}
        handleSegments={handleSegments}
        handleDeleteSegment={handleDeleteSegment}
      />
      <Options segments={segments} />
    </div>
  );
};

export default CohortBuilder;
